<template>
    <div>
         <strong>Copyright</strong>
        ©河南省卫生健康委员会 © 2021-{{ year }}
    </div>
</template>
<script>
export default {
    data() {
        var aData = new Date();
        return {
            year:aData.getFullYear() 
        }
    },
}
</script>
